import React from 'react';
import { Box } from '@medely/web-components';
import { HelpIcon } from '@medely/ui-kit';
import { useApplicationHelpIconEvent } from '@mp/hooks/analytics/useApplicationHelpIconEvent';
import show from 'utils/Intercom/show';

const ApplicationHeaderHelpIcon = ({ isMobile }: { isMobile: boolean }): React.ReactElement => {
  const { trackHelpIconOpened } = useApplicationHelpIconEvent();

  const handleChatWithSupport = () => {
    trackHelpIconOpened({ platform: 'web' });
    show();
  };

  return (
    <Box display="inline-flex" alignItems="center">
      <HelpIcon
        onPress={handleChatWithSupport}
        accessibilityLabel="Get help"
        testId="application-help-icon"
        color="text.secondary"
        iconSize={isMobile ? '15px' : '20px'}
      />
    </Box>
  );
};

export default ApplicationHeaderHelpIcon;
